import './index.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { lazy,Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FallbackUI from './components/FallbackUI';
import Navbar from "./components/Navbar";
import Footer from './pages/AboutUsPage/Footer';
//import HomePage from "";
import UserAccess from './components/UserAccess';
import PrivateRoute from './config/private-route';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { REK, ENV } from './config/api_config';
import reducers from '../src/redux/reducers';
import { createStore, applyMiddleware } from 'redux';
import { axiosAuthMiddleware } from './config/axiosMiddleware';
import reduxThunk from 'redux-thunk';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import * as Sentry from '@sentry/react';

import ScrollToTop from './components/ScrollToTop';
import GamificationProvider from './context/GamificationContext';
import ReactPixel from 'react-facebook-pixel';

import RedirectRoute from './config/redirect-route';
import { redirectUrls } from './common/constants';

import UserSubscription from './components/userSubscription';
import { ExtendChallenge } from './components/ExtendChallenge';
import TokenExpiredModal from './components/TokenExpiredModal';
import LazySpinner from './components/LazySpinner';
// import PricingPage from './pages/Pricing';

import ContentPlayer from './pages/ContentPlayerPage/ContentPlayer'
import VerificationPage from './pages/VerificationPage';
import PricingPage from './pages/Pricing';
import NewOnboardingPage from './pages/OnboardingRevampPage';
import NewLandingPage from './pages/NewLandingPage';
import QuizLoader from './pages/QuizLoader';
import Questions from './pages/PersonaliseQuestions';
import PersonalisedAnalysis from './pages/PersonalisedAnalysis';
import CertificateVerification from './pages/CertificateVerification/CertificateVerification';
import CertificateVerificationDefaultPage from './pages/CertificateVerification/CertificateVerificationDefaultPage';
import PasswordReset from './pages/PasswordReset';
import CoursePage from './pages/CoursePage';
import ContentShare from './pages/ContentShare';
import ShareCertificateRedirect from './pages/ShareCertificateRedirect';
import DeletePage from './pages/DeletePage';
import UtmData from './components/UtmData';
import LandingPage25 from './pages/LandingPage25';
import OnboardingPage25 from './pages/OnboardingPage25';
import RecruiterProfile from './pages/HallOfFamePage/RecruiterAuth/RecruiterProfile';


const HomePage = lazy(()=> import('./pages/HomePage'))
const KnowlegeGraph = lazy(() => import('./pages/KnowledgeGraph'))
// import ShareCertificate from './pages/shareCertificate';
const ShareCertificate = lazy(()=> import('./pages/shareCertificate'))
// import ExtensionLogin from './pages/ExtensionLogin';
const ExtensionLogin = lazy(()=> import('./pages/ExtensionLogin'))

//import NotesPlugin from './pages/NotesPlugin';
const NotesPlugin = lazy(()=> import('./pages/NotesPlugin'))
//import SearchResultsSection from './pages/Search';
const SearchResultsSection = lazy(()=> import('./pages/Search'))
//import ComingSoonPage from './pages/ComingSoonPage';
const ComingSoonPage = lazy(()=> import('./pages/ComingSoonPage'))
//import BeforeTabClose from "./pages/BeforeTabClose";
const BeforeTabClose = lazy(()=> import('./pages/BeforeTabClose'))
// const LandingPage = lazy(()=> import('./pages/LandingPage'))

//import MarketPlace from './pages/Marketplace';
const MarketPlace = lazy(()=> import('./pages/Marketplace'));



// const ContentPlayer = lazy(()=> import(/* webpackPrefetch: true */'./pages/ContentPlayerPage/ContentPlayer'));
//import PrivacyPolicy from './pages/PrivacyPolicy';
const PrivacyPolicy = lazy(()=> import('./pages/PrivacyPolicy'))
//import RefundPolicy from './pages/RefundPolicy';
const RefundPolicy = lazy(()=> import('./pages/RefundPolicy'))
//import TermsAndConditions from './pages/TermsAndConditions';
const TermsAndConditions = lazy(()=> import('./pages/TermsAndConditions'))
//import Contactus from './pages/Contactus';
const Contactus = lazy(()=> import('./pages/Contactus'))

// const VerificationPage = lazy(()=> import('./pages/VerificationPage'))

// import ZohoSalesIQ2 from './components/ZohoSalesIQ2';
// import Hackathon from './pages/Hackathon';
// import AboutUsPage from './pages/AboutUsPage';
const AboutUsPage = lazy(()=> import('./pages/AboutUsPage'))
const Hackathon = lazy(()=> import('./pages/Hackathon'));
// const OnboardingPage = lazy(()=> import('./pages/OnboardingPage'))
//const HomePage = lazy(()=> import('./pages/HomePage'))

//import Redirect from './pages/Redirect';
//import Certificate from "./pages/Certificate";
const Certificate = lazy(()=> import('./pages/Certificate'))
//import MSkillsPage from './pages/MSkillsPage';
const MSkillsPage = lazy(()=> import('./pages/MSkillsPage'));
//import MSkillListingPage from './pages/MSkillListingPage';
const MSkillListingPage = lazy(()=> import('./pages/MSkillListingPage'));
//import ExtensionPage from './pages/extension';
const ExtensionPage = lazy(()=> import('./pages/extension'))

//import Login from './pages/Authentication/Login';
const Login = lazy(()=> import('./pages/Authentication/Login'))
//import ProfilePage from './pages/Profile';
const ProfilePage = lazy(()=> import('./pages/Profile'));
//import PageNotFound from './pages/PageNotFound';
const PageNotFound = lazy(()=> import('./pages/PageNotFound'))
//import ProfileDetails from './pages/Authentication/ProfileDetails';
const ProfileDetails = lazy(()=> import('./pages/Authentication/ProfileDetails'))

const HallOfFame = lazy(()=> import('./pages/HallOfFamePage'))
const RecruiterPage = lazy(()=> import('./pages/HallOfFamePage/RecruiterPage'))
const RecruiterLandingPage = lazy(()=> import('./pages/HallOfFamePage/RecruiterLandingPage'))
const SkillLeaderboard = lazy(()=> import('./pages/HallOfFamePage/SkillLeaderboard'))
const LeaderboardProfiles = lazy(()=> import('./pages/HallOfFamePage/LeaderboardProfiles'))
const LeaderboardPage = lazy(()=> import('./pages/HallOfFamePage/Leaderboard'))

const Redirect = lazy(()=> import('./pages/Redirect'))


String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

const encryptor = encryptTransform({
  secretKey: REK,
  onError: function (error) {
    // Handle the error.
    console.log(error)
  }
})

const persistConfig = {
  key: 'v2',
  transforms: [encryptor],
  storage: storage,
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
  // blacklist: ['career_goal'],
};

const pReducer = persistReducer(persistConfig, reducers);
let createStoreWithMiddleware = null
createStoreWithMiddleware = applyMiddleware(
  reduxThunk,
  // logger,
  axiosAuthMiddleware
)(createStore);

export const store = (ENV === "DEVELOPMENT" || ENV === "LOCAL_DEVELOPMENT") ? createStoreWithMiddleware(
  pReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
) : createStoreWithMiddleware(
  pReducer
)

const persistor = persistStore(store);

const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: true, // enable logs
};

ReactPixel.init('333999584825866', options);


function App() {

  return (
    <Provider store={store}>
      <PersistGate loading persistor={persistor}>
        <GamificationProvider>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            className="custom-toast-container"
          />

          <Router>
            <Sentry.ErrorBoundary
              fallback={({ resetError }) => (
                <FallbackUI resetError={resetError} />
              )}
            >
              <Navbar />
              <UtmData/>
              {/* <PricingBanner /> */}
              <ScrollToTop>
                <UserSubscription />
                {/* <ZohoSalesIQ2/> */}
                <UserAccess />
                {/* <div className="overflow-x-hidden h-screen scroll"> */}
                <Routes>
                  <Route exact path="/" element={<LandingPage25/>} />
                  <Route path="*" element={<Suspense fallback={<LazySpinner/>}><PageNotFound /></Suspense>} />
                  <Route exact path="/error" element={<Suspense fallback={<LazySpinner/>}><PageNotFound /></Suspense>} />
                  <Route exact path="/courses" element={<Suspense fallback={<LazySpinner/>}><HomePage /></Suspense>}></Route>
                  <Route exact path="/verification" element={<VerificationPage/>}/>
                  <Route exact path="/hackathon" element={<Suspense fallback={<LazySpinner/>}><Hackathon/></Suspense>}/>
                  <Route exact path='/about-us' element={<Suspense fallback={<LazySpinner/>}><AboutUsPage/></Suspense>}/>
                  <Route exact path='/knowledge-graph' element={<Suspense fallback={<LazySpinner/>}><KnowlegeGraph/></Suspense>}/>
                  <Route
                    path="/popular-course/:course"
                    element={<CoursePage/>}
                  />
                  <Route exact path='/share/:uuid' element={<Suspense fallback={<LazySpinner/>}><ContentShare/></Suspense>}></Route>
                  <Route path="/redirect" element={<Suspense fallback={<LazySpinner/>}><Redirect /></Suspense>} />
                  {redirectUrls.map((item) => (
                    <Route
                      path={item}
                      element={<RedirectRoute></RedirectRoute>}
                    />
                  ))}
                  {/* login route */}
                  <Route path="/login" element={<Suspense fallback={<LazySpinner/>}><Login /></Suspense>} />

                  <Route
                    path="/onboarding"
                    exact
                    element={
                      <PrivateRoute>
                        <OnboardingPage25/>
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/onboarding/loader"
                    exact
                    element={
                      <PrivateRoute>
                        <QuizLoader />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/onboarding/questions/:id"
                    exact
                    element={
                      <PrivateRoute>
                        <Questions />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/onboarding/analysis"
                    exact
                    element={
                      <PrivateRoute>
                        <PersonalisedAnalysis />
                      </PrivateRoute>
                    }
                  />

                  {/* List of all skills for course_slug */}
                  <Route
                    path="/:course_slug"
                    key={window.location.pathname}
                    element={<Suspense fallback={<LazySpinner/>}><MSkillsPage /></Suspense>}
                  />
                  {/* <Route
                    path="/:course_slug"
                    key={window.location.pathname}
                    element={<SkillListingPage />}
                  /> */}

                  {/*  List of all micro skills for skill Id */}
                  <Route
                    path="/:course_slug/:skill_slug"
                    key={window.location.pathname}
                    element={<Suspense fallback={<LazySpinner/>}><MSkillListingPage /></Suspense>}
                  />
                  <Route path="/user/delete" element={<PrivateRoute><DeletePage/></PrivateRoute> }/>
                  {/* Content player for particular content i=Id */}
                  <Route
                    path="/:course_slug/:skill_slug/:mskill_slug"
                    element={
                      <PrivateRoute>
                        <ContentPlayer />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/:course_slug/:skill_slug/:mskill_slug/:contentId"
                    exact
                    element={
                      <PrivateRoute>
                        <ContentPlayer />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/:course_slug/:skill_slug/:mskill_slug/:contentId/:new_user"
                    exact
                    element={<ContentPlayer />}
                  />
                  {/* profile-details */}
                  <Route
                    path="/profile-details"
                    exact
                    element={<Suspense fallback={<LazySpinner/>}><ProfileDetails /></Suspense>}
                  />

                  {/* My profile page */}
                  <Route
                    path="/my-profile/user/*"
                    element={
                      <PrivateRoute>
                        <Suspense fallback={<LazySpinner/>}><ProfilePage /></Suspense>
                      </PrivateRoute>
                    }
                  />
                  <Route path="/verify/certificate/:uuid" element={<Suspense fallback={<LazySpinner/>}><CertificateVerification/></Suspense>}/>
                  <Route exact path="/verify/certificate" element={<Suspense fallback={<LazySpinner/>}><CertificateVerificationDefaultPage/></Suspense>}/>
                  <Route path="/setup-extension" element={ <Suspense fallback={<LazySpinner/>}><ExtensionPage /></Suspense>} />
                  <Route path="/login-extension" element={ <Suspense fallback={<LazySpinner/>}><ExtensionLogin /></Suspense>} />
                  <Route path="/notes-extension" element={ <Suspense fallback={<LazySpinner/>}><NotesPlugin /></Suspense>} />
                  <Route exact path="/share-certificate" element={<ShareCertificateRedirect/>}></Route>
                  {/* Search Page */}
                  <Route
                    exact
                    path="/search"
                    element={<Suspense fallback={<LazySpinner/>}><SearchResultsSection /></Suspense>}
                  />
                  <Route exact path="/certificate" element={<Suspense fallback={<LazySpinner/>}><Certificate /></Suspense>} />

                  {/* Coming Soon Page */}
                  <Route exact path="/beta" element={<Suspense fallback={<LazySpinner/>}><ComingSoonPage /></Suspense>} />
                  <Route exact path="/market-place" element={<Suspense fallback={<LazySpinner/>}><MarketPlace /></Suspense>} />

                  {/* Support Pages */}
                  <Route
                    exact
                    path="/privacypolicy"
                    element={<Suspense fallback={<LazySpinner/>}><PrivacyPolicy /></Suspense>}
                  />
                  <Route
                    exact
                    path="/refundpolicy"
                    element={<Suspense fallback={<LazySpinner/>}><RefundPolicy /></Suspense>}
                  />
                  <Route
                    exact
                    path="/termsandconditions"
                    element={<Suspense fallback={<LazySpinner/>}><TermsAndConditions /></Suspense>}
                  />
                  <Route exact path="/contactus" element={<Suspense fallback={<LazySpinner/>}><Contactus /></Suspense>} />
                  <Route exact path='/pricing' element={<PricingPage />} />
                  <Route exact path='/price' element={<Suspense fallback={<LazySpinner/>}><PricingPage route={2} /></Suspense>} />
                  <Route exact path='/set-password' element={<Suspense fallback={<LazySpinner/>}><PasswordReset/></Suspense>} />
                  {/* Shareable certificate link */}
                 
                  <Route
                    exact
                    path="/share-certificate/:type/:ref"
                    element={<Suspense fallback={<LazySpinner/>}><ShareCertificate /></Suspense>}
                  />
                 
                  {/* Hall of fame */}
                  <Route exact path='/halloffame' element={<Suspense fallback={<LazySpinner/>}><HallOfFame /></Suspense>} />
                  <Route exact path='/halloffame/:skill_name' key={window.location.pathname} element={<Suspense fallback={<LazySpinner/>}><SkillLeaderboard /></Suspense>} />
                  <Route exact path='/recruiter' element={<Suspense fallback={<LazySpinner/>}><RecruiterLandingPage /></Suspense>} />
                  <Route exact path='/recruiter/signup' element={<Suspense fallback={<LazySpinner/>}><RecruiterPage /></Suspense>} />
                  <Route exact path='/recruiter/results' element={<Suspense fallback={<LazySpinner/>}><LeaderboardProfiles /></Suspense>} />
                  <Route exact path='/recruiter/profile' element={<Suspense fallback={<LazySpinner/>}><RecruiterProfile /></Suspense>} />
                  <Route exact path='/leaderboard' element={<Suspense fallback={<LazySpinner/>}><LeaderboardPage /></Suspense>} />
                </Routes>

              
                {/* </div> */}
                <Suspense fallback={<LazySpinner/>}><Footer /></Suspense>
                
                
                <Suspense fallback={<LazySpinner/>}><BeforeTabClose /></Suspense>
                
                <TokenExpiredModal />
                {/* <WelcomeUserModal /> */}
                {/* <LockUserModal /> */}
                {/* <LockUserModalRevamp/> */}
              </ScrollToTop>
              <ExtendChallenge />
            </Sentry.ErrorBoundary>
          </Router>

        </GamificationProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
